var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 13.9996H14.7099L14.4299 13.7296C15.6299 12.3296 16.2499 10.4196 15.9099 8.38965C15.4399 5.60965 13.1199 3.38965 10.3199 3.04965C6.08989 2.52965 2.52989 6.08965 3.04989 10.3196C3.38989 13.1196 5.60989 15.4396 8.38989 15.9096C10.4199 16.2496 12.3299 15.6296 13.7299 14.4296L13.9999 14.7096V15.4996L18.2499 19.7496C18.6599 20.1596 19.3299 20.1596 19.7399 19.7496C20.1499 19.3396 20.1499 18.6696 19.7399 18.2596L15.4999 13.9996ZM9.49989 13.9996C7.00989 13.9996 4.99989 11.9896 4.99989 9.49965C4.99989 7.00965 7.00989 4.99965 9.49989 4.99965C11.9899 4.99965 13.9999 7.00965 13.9999 9.49965C13.9999 11.9896 11.9899 13.9996 9.49989 13.9996Z",
    fill: "#5F7584"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.146e8b7f1e4a27591a136a93648a73e3.svg";
export { ForwardRef as ReactComponent };